import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Button, Grid, Typography } from '@material-ui/core';
import { useGetBooksCSVQuery, useGetBooksQuery } from '../../../store/apiSlice';
import React, { useEffect, useState } from 'react';
import AddIcon from '@material-ui/icons/Add';
import ArrowCircleDownIcon from '@material-ui/icons/ArrowDownwardOutlined';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import { BookForm } from '../../../components/BookForm';
import { PageNav } from '../../../components/pageNav';
import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';

// mui table imports
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Skeleton } from '@material-ui/lab/';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../store/authSlice';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	paper: {
		padding: theme.spacing(2),
	},
	spacer: {
		margin: theme.spacing(2),
	},
	title: {
		paddingBottom: theme.spacing(2),
	},
	table: {
		minWidth: 650,
	},
	grid: {
		borderColor: theme.palette.secondary,
		borderBottom: '1px solid',
		marginTop: theme.spacing(1),
	},
	flex: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
		gap: theme.spacing(1),
	},
}));

function AdminCatalogue() {
	const classes = useStyles();
	const [pageInput, setPageInput] = useState(1);
	const [settings, setSettings] = useState({ page: 1 });

	const { data: bookData, isFetching } = useGetBooksQuery({
		...settings,
		page: pageInput,
	});

	const firstResultRef = useRef(null);
	const errorMessageRef = useRef(null);

	useEffect(() => {
		if (bookData && bookData.books.length > 0) {
			// if (firstResultRef.current) firstResultRef.current.focus();
		} else if (!books.length) {
			errorMessageRef.current.tabIndex = 0;
			errorMessageRef.current.focus();
		}
	}, [bookData]);

	useEffect(() => {
		setPageInput(1);
	}, [settings]);

	const handlePageMove = (sign) => () => {
		setPageInput((prevState) => prevState + 1 * sign);
	};

	const handleInputChange = (e) => {
		e.persist();
		const newValue = Math.min(
			Math.max(e.target.value, 1),
			bookData?.pageCount || pageInput
		);
		setPageInput(newValue);
	};

	let books = bookData?.books || Array.from({ length: 20 });

	const { data } = useGetBooksCSVQuery();

	console.log(data);
	const user = useSelector(selectCurrentUser);
	console.log(user);
	const handleCSV = async () => {
		try {
			const csvData = await fetch('/api/admin/book/csv', {
				method: 'GET',
				headers: new Headers({
					Authorization: `Bearer ${user.jwt}`,
				}),
			});
			const blob = await csvData.blob();

			const url = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = url;
			a.download = 'books.csv';
			document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
			a.click();
			a.remove(); //afterwards we remove the element again
		} catch (err) {
			console.log('Could not get csv');
		}
	};

	return (
		<div className={classes.root}>
			<CssBaseline />
			<Helmet>
				<title>Каталог</title>
			</Helmet>

			<Container maxWidth="lg" className={classes.container}>
				<Paper className={classes.paper}>
					<Typography
						className={classes.title}
						component="h1"
						variant="h4"
						role="alert"
					>
						Каталог
					</Typography>
					<div className={classes.spacer}>
						<Button startIcon={<AddIcon />}>
							<Link to="/admin/catalogue/create">Добави</Link>
						</Button>
						<Button startIcon={<ArrowCircleDownIcon />} onClick={handleCSV}>
							Export
						</Button>
						<Button startIcon={<ArrowCircleDownIcon />}>Export Excel</Button>
					</div>
					<TableContainer component={Paper}>
						<Table className={classes.table} aria-label="Каталог">
							<TableHead>
								<TableRow>
									<TableCell>Заглавие</TableCell>
									<TableCell>Автор</TableCell>
									<TableCell align="right">Редактирай</TableCell>
									<TableCell align="right">Изтрий</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{books.map((book, index) => (
									<TableRow key={index}>
										<TableCell scope="row">
											{!isFetching ? (
												<Link
													ref={firstResultRef}
													to={`../catalogue/${book.id}`}
												>
													{book.title}
												</Link>
											) : (
												<Skeleton width={'25vw'} />
											)}
										</TableCell>
										<TableCell align="left">
											{!isFetching ? (
												book.author?.name
											) : (
												<Skeleton width={'25vw'} />
											)}
										</TableCell>
										<TableCell align="right">
											<Link
												ref={firstResultRef}
												to={`/admin/catalogue/edit/${book?.id}`}
												state={{ name: book?.name }}
											>
												<Button
													startIcon={<EditIcon />}
													aria-label="Редактиране на книга"
												></Button>
											</Link>
										</TableCell>
										<TableCell align="right">
											{!isFetching ? (
												<Link to={`/admin/catalogue/delete/${book?.id}`}>
													<Button
														startIcon={<DeleteIcon />}
														aria-label="Изтриване на книга"
													></Button>
												</Link>
											) : (
												<Skeleton width={40} />
											)}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
					{books.length ? (
						<PageNav
							isFetching={isFetching}
							maxPage={bookData?.pageCount}
							handlePageMove={handlePageMove}
							pageInput={pageInput}
							handleInputChange={handleInputChange}
						/>
					) : (
						<Typography ref={errorMessageRef}>Няма намерени книги.</Typography>
					)}
					<BookForm setSettings={setSettings} />
				</Paper>
			</Container>
		</div>
	);
}

export default AdminCatalogue;
